// Retratos reales y variados: selfies, espejo, cocina, taller, exterior.
export const heroAvatars = [
  'https://cdn.magicpatterns.com/patterns/generated-images/86a397de-4e26-419b-a70f-352f087615cf.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/c6be123d-b3f0-49aa-80ea-8f542af7345c.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/44abd435-dc61-4a0c-9138-f314ab999501.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/023e86a2-3bed-47a1-b008-63eac38410e1.jpg',
]

export const testimonialAvatars = [
  'https://cdn.magicpatterns.com/patterns/generated-images/83f4ca4d-1ae9-4a53-85e9-a2b79705120f.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/82344a83-a63f-49b3-8e30-42511cb15c62.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/f410f387-f081-421d-a33a-5923c4ccd9a0.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/35888438-df06-4586-89cf-5da54b578387.jpg',
]
